import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import { List } from '@mui/material';
import MenuItem from '../shared/menu/MenuItem';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import useAuth from "../../hooks/useAuth";
import { roleOptions } from "../../utils/appRoles";
import {useLocation} from 'react-router-dom';

const drawerWidth = 250;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
    
  }),
);

const SideBar = ({open}) => {
  const {auth} = useAuth();    
  const userType = auth?.user?.type;
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', height: "100%"}}>
      <Drawer 
        variant="permanent" 
        open={open}
        sx={{
          '& .MuiDrawer-paper': {
            position: "static"
          }
        }}
      >
        <List>
          <MenuItem 
            open={open}
            text="Accueil"
            link="/"
            icon={<HomeOutlinedIcon
              sx={{
                color: location.pathname === "/" || location.pathname.startsWith("/article/view") ? "rgb(16, 87, 200)" : "rgba(0, 0, 0, 0.54)"
              }}
            />}
          />
          {userType === roleOptions.HR || userType === roleOptions.ADMIN ? 
            <div>
              <MenuItem 
                text="Utilisateurs"
                link="/users"
                open={open}
                icon={<PeopleOutlineOutlinedIcon
                  sx={{
                    color: location.pathname.startsWith("/users") ? "rgb(16, 87, 200)" : "rgba(0, 0, 0, 0.54)"
                  }}
                />}
              />
              {/* <MenuItem
                text="Créer Utilisateur"
                link="/users/create"
                open={open}
                icon={<PersonAddOutlinedIcon/>}
              /> */}
              <MenuItem
                  text="Articles"
                  link="/article"
                  open={open}
                  icon={<DescriptionOutlinedIcon 
                    sx={{
                      color: location.pathname.startsWith("/article") && !location.pathname.startsWith("/article/view") ? "rgb(16, 87, 200)" : "rgba(0, 0, 0, 0.54)"
                    }}
                  />}                  
              />
            </div>           
          : null}                         
        </List>
      </Drawer>
    </Box>
  );
};

export default  SideBar;